var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-card shadow-sm"},[_c('div',{staticClass:"avatar-card__avatar",style:(`background-image: url(${_vm.avatar}); background-color: ${
      _vm.backgroundColour ? _vm.backgroundColour : 'white'
    }`)}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }